import ViewStatementPage from "components/pages/ViewStatementPage";

export default function CapturreMabiEStatementsEnrollScreen(props) {
    return <ViewStatementPage />
}